@import '../../global/animations.scss';

$cap-height-ratio: 0.72;
$displaySizes: 1, 2;
$headlines: 1, 2, 3, 4, 5, 6;

.headline-container {
  overflow: hidden;
  @apply font-head;

  &.white-font {
    @apply text-white;
  }

  .card-separator {
    @apply bg-black;

    &.white {
      @apply bg-white;
    }
  }

  &.none .card-separator {
    @apply bg-transparent;
  }

  @each $headline in $displaySizes {
    .display-#{$headline} {
      @apply break-words;
      @apply inline;
      font-size: var(--display#{$headline}-font-size);
      line-height: var(--display#{$headline}-line-height);
    }

    &.display-#{$headline} .card-separator-top {
      width: var(--headline-width);
      height: var(--seperator-height-h#{$headline});
      margin-bottom: calc(0.12 * calc(var(--display#{$headline}-font-size) * #{$cap-height-ratio}));
    }

    &.display-#{$headline} .card-separator-bottom {
      width: var(--headline-width);
      height: var(--seperator-height-h#{$headline});
      margin-top: calc(0.3 * calc(var(--display#{$headline}-font-size) * #{$cap-height-ratio}));
    }

    &.display-#{$headline} .card-separator-bottom-only {
      width: calc(var(--display#{$headline}-font-size) * 2 * #{$cap-height-ratio});
      height: var(--seperator-height-h#{$headline});
      margin-top: calc(0.3 * calc(var(--display#{$headline}-font-size) * #{$cap-height-ratio})) !important;
    }
  }

  @each $headline in $headlines {
    h#{$headline} {
      @apply break-words;
      @apply inline;
      font-size: var(--h#{$headline}-font-size);
      line-height: var(--h#{$headline}-line-height);
    }

    &.h#{$headline} .card-separator-top {
      width: var(--headline-width);
      height: var(--seperator-height-h#{$headline});
      margin-bottom: calc(0.12 * calc(var(--h#{$headline}-font-size) * #{$cap-height-ratio}));
    }

    &.h#{$headline} .card-separator-bottom {
      width: var(--headline-width);
      height: var(--seperator-height-h#{$headline});
      margin-top: calc(0.3 * calc(var(--h#{$headline}-font-size) * #{$cap-height-ratio}));
    }

    &.h#{$headline} .card-separator-bottom-only {
      width: calc(var(--h#{$headline}-font-size) * 2 * #{$cap-height-ratio});
      height: var(--seperator-height-h#{$headline});
      margin-top: calc(0.3 * calc(var(--h#{$headline}-font-size) * #{$cap-height-ratio})) !important;
    }
  }

  &.later {
    opacity: 0;
    .card-separator {
      transform: scale(0, 1);
    }
  }

  &.now {
    animation-name: fadeIn;
    animation-duration: 1.5s;
    animation-delay: 0s;
    animation-fill-mode: backwards;

    &.hero {
      animation-delay: 1s;
      .card-separator {
        animation-delay: 1s;
      }
    }

    .card-separator {
      background-color: var(--color-black);
      transform-origin: left;
      animation-name: scaleSeparator;
      animation-duration: 2s;
      animation-delay: 0s;
      animation-fill-mode: backwards;
      animation-timing-function: ease-out;

      &.white {
        @apply bg-white;
      }
    }
  }
}

.white-font {
  color: white !important;
}
